var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export var StyledLabelWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: fit-content;\n  label{\n    font-family: 'AvenirLight';\n  }\n"], ["\n  display: block;\n  width: fit-content;\n  label{\n    font-family: 'AvenirLight';\n  }\n"])));
var Label = function (_a) {
    var label = _a.label, htmlFor = _a.htmlFor, children = _a.children;
    return (_jsxs(StyledLabelWrapper, { children: [_jsx("label", __assign({ htmlFor: htmlFor }, { children: label && label.toUpperCase() })), children && children] }));
};
export default Label;
var templateObject_1;
